"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Insight = exports.InsightOptions = void 0;
const url_1 = require("./helpers/url");
const api = __importStar(require("./helpers/api"));
const SymbolFlags_1 = require("./models/SymbolFlags");
const Environment_1 = require("./enums/Environment");
const faucet_1 = require("./faucet/faucet");
const syft_1 = require("./syft");
const iceboxFallback_1 = require("./iceboxFallback");
const icebox_1 = require("./icebox");
const syphon_1 = require("./syphon");
const quay_1 = require("./quay");
const System_1 = require("./models/System");
/**
 * The main options used when instantiating an instance of the Insight Market SDK.
 *
 * @export
 * @class InsightOptions
 */
class InsightOptions {
}
exports.InsightOptions = InsightOptions;
/**
 * The main Insight Market SDK class.  Instantiated with a valid API token and options such
 * as which environment to use, a locale, and any endpoint overrides desired.
 *
 * @export
 * @class Insight
 */
class Insight {
    /**
     * Creates an instance of the Insight Market SDK.  If the environment is not specified it will
     * default to Production, and if the locale isn't specified it will default to Japanese.
     * @param {InsightOptions} options
     * @memberof Insight
     */
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        this.channels = {};
        this.bar = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
                this.stream = new (class {
                    constructor(outerThis, type = 'bar') {
                        this.outerThis = outerThis;
                        this.type = type;
                    }
                    /**
                     * Starts bar stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.bar
                     */
                    start(symbol) {
                        this.outerThis._faucet.start(`${symbol}/${this.type}`);
                    }
                    /**
                     * Stops bar stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.bar
                     */
                    async stop(symbol) {
                        this.outerThis._faucet.stop(`${symbol}/${this.type}`);
                    }
                })(this.parentThis);
            }
            /**
             * Returns a snapshot of the bar for the specified symbol.
             *
             * @param {string} symbol
             * @return {*}  {Promise<TickRow[]}
             * @memberof Insight.bar
             */
            async snapshot(symbol) {
                return await this.parentThis._icebox.symbolBarSnapshot(symbol);
            }
        })(this);
        this.intraday = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
                this.stream = new (class {
                    constructor(outerThis, type = 'intraday') {
                        this.outerThis = outerThis;
                        this.type = type;
                    }
                    /**
                     * Starts intraday stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.intraday
                     */
                    start(symbol) {
                        this.outerThis._faucet.start(`${symbol}/${this.type}`);
                    }
                    /**
                     * Stops intraday stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.intraday
                     */
                    async stop(symbol) {
                        this.outerThis._faucet.stop(`${symbol}/${this.type}`);
                    }
                })(this.parentThis);
            }
            /**
             * Returns a snapshot of the intraday for the specified symbol.
             *
             * @param {string} symbol
             * @return {*}  {Promise<TickRow[]}
             * @memberof Insight.intraday
             */
            async snapshot(symbol) {
                return await this.parentThis._icebox.symbolIntradaySnapshot(symbol);
            }
        })(this);
        this.matrix = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
                this.stream = new (class {
                    constructor(outerThis, type = 'matrix') {
                        this.outerThis = outerThis;
                        this.type = type;
                    }
                    /**
                     * Starts matrix stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.matrix
                     */
                    start(symbol) {
                        this.outerThis._faucet.start(`${symbol}/${this.type}`);
                    }
                    /**
                     * Stops matrix stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.matrix
                     */
                    async stop(symbol) {
                        this.outerThis._faucet.stop(`${symbol}/${this.type}`);
                    }
                })(this.parentThis);
            }
            /**
             * Returns a snapshot of the matrix for the specified symbol.
             *
             * @param {string} symbol
             * @return {*}  {Promise<TickRow[]}
             * @memberof Insight.matrix
             */
            async snapshot(symbol) {
                return await this.parentThis._icebox.symbolMatrixSnapshot(symbol);
            }
        })(this);
        this.miniquote = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
                this.stream = new (class {
                    constructor(outerThis, type = 'miniquote') {
                        this.outerThis = outerThis;
                        this.type = type;
                    }
                    /**
                     * Starts miniquote stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.miniquote
                     */
                    start(symbol) {
                        this.outerThis._faucet.start(`${symbol}/${this.type}`);
                    }
                    /**
                     * Stops miniquote stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.miniquote
                     */
                    async stop(symbol) {
                        this.outerThis._faucet.stop(`${symbol}/${this.type}`);
                    }
                })(this.parentThis);
            }
            /**
             * Returns a snapshot of the miniquote for the specified symbol.
             *
             * @param {string} symbol
             * @return {*}  {Promise<TickRow[]}
             * @memberof Insight.miniquote
             */
            async snapshot(symbol) {
                return await this.parentThis._icebox.symbolMiniquoteSnapshot(symbol);
            }
        })(this);
        this.quote = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
                this.stream = new (class {
                    constructor(outerThis, type = 'quote') {
                        this.outerThis = outerThis;
                        this.type = type;
                    }
                    /**
                     * Starts quote stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.quote
                     */
                    start(symbol) {
                        this.outerThis._faucet.start(`${symbol}/${this.type}`);
                    }
                    /**
                     * Stops quote stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.quote
                     */
                    async stop(symbol) {
                        this.outerThis._faucet.stop(`${symbol}/${this.type}`);
                    }
                })(this.parentThis);
            }
            /**
             * Returns a snapshot of the quote for the specified symbol.
             *
             * @param {string} symbol
             * @return {*}  {Promise<Quote>}
             * @memberof Insight.quote
             */
            async snapshot(symbol) {
                return await this.parentThis._icebox.symbolQuoteSnapshot(symbol);
            }
        })(this);
        /**
         * This is the symbol class
         *
         */
        this.symbol = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
            }
            /**
             * Returns an array of SymbolMetadata for symbols matching the provided pattern.
             * Searches can be on symbol name (in English, Japanese, or Kana), as well as
             * Japanese keywords and symbol codes.
             *
             * Possible Exceptions are:
             * PATTERN_MISSING - No pattern was specified
             *
             *
             * @param {string} pattern - Required. The search pattern to use. Wildcards and other special characters are not supported. Syft will look up the given pattern in its precomputed match database and return the metadata for all symbols that contain the pattern as given.
             * @param {number?} top - Limits the returned symbols to a maximum number. Must be a positive integer in the range 1-1000 (inclusive). If no value is provided, if it is set to a non-number, or if a value greater than 1000 is provided, this parameter is set to 1000. If a value less than 1 is provided, this parameter is set to 1.
             * @param {number?} skip - Skips past a certain number of symbols. Must be a non-negative integer. The top limiter is applied after skip. If the value of skip is greater than or equal to the total number of symbols, no symbols will be returned. If no value is provided, if it is set to a non-number, or if a negative value is provided, this parameter is set to 0.
             * @param {boolean} jpeq - Boolean: when added, and set to true, Japanese Equity symbols (e.g. JP:7203-TS) will be returned. Defaults to true
             * @param {boolean} useq - Boolean: when added, and set to true, US Equity symbols (e.g. AAPL, MSFT) will be returned. Defaults to true
             * @param {boolean} supplemental - Boolean: when added, and set to true, supplemental symbols (e.g. bonds, indexes, forex, commodities) will be returned. Defaults to true
             * @param {boolean} industry - Boolean: when added, and set to true, Industry Symbols (e.g. 金属製品) will be returned, Defaults to true
             * @return {*}  {Promise<ApiResponse<SymbolMetadata[]>>}
             * @memberof Insight.symbol
             * @example
             * Performing a symbol search on 8698
             * ```ts
             *  let searchByPattern = await sdk.symbol.searchByPattern('8698');
             * ```
             * @example
             * Performing a symbol search on Apple for the top 10 US Equity symbols, but skipping the first result
             * ```ts
             * let searchByPattern = await sdk.symbol.searchByPattern('Apple', 10, 1, false, true, false, false);
             * ```
             * @example
             * Performing a symbol search for the firs industry symbol for metal
             * ```ts
             * let searchByPattern = await sdk.symbol.searchByPattern('金属', 1, 0, true, false, false, true);
             * console.log(searchByPattern);
             * ```
             */
            async searchByPattern(pattern, top, skip, jpeq = true, useq = true, supplemental = true, industry = true) {
                return await this.parentThis._syft.symbolSearch(pattern, top, skip, jpeq, useq, supplemental, industry);
            }
            /**
             * Returns the SymbolMetadata for the specified symbol.
             *
             * @param {string} symbol - Identifies the symbol for which to return metadata. This parameter must follow the symbol name format in TradeStation symbology. (US equity symbols are referred to by their codes, such as TSLA, whereas Japanese equity symbols are preceded by JP: and are followed by an exchange suffix, such as JP:7203-TS.) If the given ID contains any lower- case characters, it is converted to upper-case.
             * <br /><br />
             * A valid symbol ID consists of at least one of the following characters:
             * <br /><br />
             * - Upper- or lower-case Latin letters <br />
             * - Digits <br />
             * - Any of the following special characters: @:$.-
             * @return {*}  {Promise< ApiResponse<SymbolMetadata>>}
             * @memberof Insight.symbol
             * @example
             * ```ts
             * let symbol = await sdk.symbol.searchByCode('JP:$MNK');
             * console.log(symbol);
             * ```
             */
            async searchByCode(symbol) {
                return await this.parentThis._syft.symbolMetadata(symbol);
            }
            /**
             * Returns a list of symbols for the specified index.
             *
             * @param {string} index - Identifies the list to return symbol names for. A complete list of valid values can be found at via the getLists() command.
             * @return {*}  {Promise< ApiResponse<SymbolList | SymbolListError>>}
             * @memberof Insight.symbol
             * @example
             * Example request to get a list of symbols for NIKKEI225
             * ```ts
             *   let symbolNames = await sdk.symbol.getList('NIKKEI225');
             *   console.log(symbolNames);
             * ```
             */
            async getList(index) {
                return await this.parentThis._syft.getList(index);
            }
            /**
             * Returns a list of the available indexes.
             *
             * @return {*}  {Promise< ApiResponse<IndexList | IndexListError>>}
             * @memberof Insight.symbol
             * @example
             * ```ts
             *   let indexes = await sdk.symbol.getLists();
             *   console.log(indexes);
             * ```
             */
            async getLists() {
                return await this.parentThis._syft.getLists();
            }
            /**
             * Gets a list of symbols from the symbol universe
             *
             * @param {number?} top - Optional. Specifies how many symbols to be returned in one query. Defaults to 100.
             * @param {number?} skip - Optional. Skips the first x symbols that would be returned. Can be used in conjunction with top to split the symbol universe across multiple requests. Defaults to 0.
             * @return {*}  {Promise<ApiResponse<SymbolUniverse>>}
             * @memberof Insight.symbol
             * @example
             * Making a request to get the top 10 symbols from the Symbol Universe, however skip 5 of them
             * ```ts
             * let symbols = await sdk.symbol.symbolUniverse(10, 5);
             * console.log(symbols);
             * ```
             */
            async getAllSymbolCodes(top, skip) {
                return await this.parentThis._syft.symbolUniverse(top, skip);
            }
            /**
             * Returns the margin and negotiated margin restriction flags for the specified symbol.
             *
             * @param {string} symbol
             * @return {*}  {Promise<SymbolFlags>}
             * @memberof Insight.symbol
             */
            async flags(symbol) {
                const apiUrl = this.parentThis._getApiUrl();
                const result = await api.get((0, url_1.buildFullyQualifiedUrl)(apiUrl, `market/flags/${symbol}`), this.parentThis._token);
                return new SymbolFlags_1.SymbolFlags(result);
            }
            /**
             * Returns the fundamentals for the specified symbol.
             *
             * @param {string} symbol
             * @return {*}  {Promise<{ [key: string]: FundamentalData }>}
             * @memberof Insight.symbol
             */
            async fundamentals(symbol) {
                return await this.parentThis._syphon.getFundamentals(symbol);
            }
        })(this);
        this.tick = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
                this.stream = new (class {
                    constructor(outerThis, type = 'tick') {
                        this.outerThis = outerThis;
                        this.type = type;
                    }
                    /**
                     * Starts tick stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.tick
                     */
                    start(symbol) {
                        this.outerThis._faucet.start(`${symbol}/${this.type}`);
                    }
                    /**
                     * Stops tick stream for the specified symbol.
                     *
                     * @param {string} symbol
                     * @return {*}  void
                     * @memberof Insight.tick
                     */
                    async stop(symbol) {
                        this.outerThis._faucet.stop(`${symbol}/${this.type}`);
                    }
                })(this.parentThis);
            }
            /**
             * Returns a snapshot of the tick for the specified symbol.
             *
             * @param {string} symbol
             * @return {*}  {Promise<TickRow[]}
             * @memberof Insight.tick
             */
            async snapshot(symbol) {
                return await this.parentThis._icebox.symbolTickSnapshot(symbol);
            }
        })(this);
        this.message = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
            }
            /**
             * Returns the active global messages for the user.
             *
             * @return {*}  {Promise<Message[]}
             * @memberof Insight.message
             */
            async getAll() {
                return await this.parentThis._quay.getActiveGlobalMessages();
            }
        })(this);
        this.news = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
            }
            /**
             * Returns global news headlines.
             *
             * @param {number?} top
             * @return {*}  {Promise<Headlines[]>}
             * @memberof Insight.news
             */
            async getHeadlines(top) {
                return await this.parentThis._syphon.getHeadlines(top);
            }
            /**
             * Returns news headlines for the specified symbol.
             *
             * @param {string} symbol
             * @param {number?} top
             * @return {*}  {Promise<Headlines[]>}
             * @memberof Insight.news
             */
            async getHeadlinesBySymbol(symbol, top) {
                return await this.parentThis._syphon.getHeadlinesBySymbol(symbol, top);
            }
            /**
             * Returns an article for the specified id.
             *
             * @param {string} id
             * @return {*}  {Promise<Article>}
             * @memberof Insight.news
             */
            async getArticleById(id) {
                return await this.parentThis._syphon.getArticleById(id);
            }
            /**
             * Returns the latest TSE article.
             *
             * @return {*}  {Promise<Article>}
             * @memberof Insight.news
             */
            async getLatestTSEArticle() {
                return await this.parentThis._syphon.getLatestTSEArticle();
            }
        })(this);
        this.hotlists = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
            }
            /**
             * Returns the hotlist with the specified hotlistName
             *
             * @param {string} hotlistName The name of the hotlist.
             * @param {string?} exchange The exchange that will be used to filter the results of the hotlist.
             * @param {string:} sector The sector that will be used to filter the results of the hotlist.
             * @return {*}  {Promise<Hotlist>>}
             * @memberof Insight
             */
            async getHotlistByName(hotlistName, exchange, sector) {
                return await this.parentThis._syphon.getHotlistByName(hotlistName, exchange, sector);
            }
        })(this);
        this.scans = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
            }
            /**
             * Returns the scanResults for the specified scanName
             *
             * @param {string} scanName The name of the scan.
             * @return {*}  {Promise<ScanResults>}
             * @memberof Insight
             */
            async getScanResults(scanName) {
                return this.parentThis._syphon.getScanResults(scanName);
            }
        })(this);
        this.system = new (class {
            constructor(parentThis) {
                this.parentThis = parentThis;
            }
            /**
             * Returns the status of insight { maintenance: boolean }
             *
             * @return {*} {Promise<System>}
             * @memberof Insight
             */
            async getStatus() {
                const apiUrl = this.parentThis._getApiUrl();
                const result = await api.get((0, url_1.buildFullyQualifiedUrl)(apiUrl, 'system/status'), this.parentThis._token);
                return new System_1.System(result.system);
            }
        })(this);
        // Require a token to create the SDK, as only Syft will work
        // without one.
        if (!options.token) {
            throw new Error('TOKEN_MISSING');
        }
        this._token = options.token;
        // Load in the specified values, otherwise load in the defaults
        this._environment = (_a = options.environment) !== null && _a !== void 0 ? _a : Environment_1.Environment.Production;
        // Load in any specified overrides for different services
        this._apiUrlOverride = (_b = options.apiUrlOverride) !== null && _b !== void 0 ? _b : null;
        this._syftUrlOverride = (_c = options.syftUrlOverride) !== null && _c !== void 0 ? _c : null;
        this._iceboxUrlOverride = (_d = options.iceboxUrlOverride) !== null && _d !== void 0 ? _d : null;
        this._faucetUrlOverride = (_e = options.faucetUrlOverride) !== null && _e !== void 0 ? _e : null;
        this._quayUrlOverride = (_f = options.quayUrlOverride) !== null && _f !== void 0 ? _f : null;
        this._faucet = new faucet_1.FaucetClient({
            host: this._getFaucetUrl(),
            secure: true,
            port: 443,
            token: this._token
        });
        this.channels = this._faucet.channels;
        this._syft = new syft_1.SyftClient(this._getSyftUrl(), options.locale);
        this._icebox = new icebox_1.Icebox(this._getIceboxUrl(), this._token);
        this._fallbackPolling = new iceboxFallback_1.IceboxFallback(this._faucet, this._icebox, this.channels, options.fallbackPollingIntervalSeconds);
        this._syphon = new syphon_1.SyphonClient({
            apiUrl: this._getApiUrl(),
            token: this._token
        });
        this._quay = new quay_1.Quay(this._getQuayUrl());
    }
    /**
     * Gets the base API Gateway URL for the environment specified when instantiating the SDK.
     * Used as the base for Syphon, Yacht, and System APIs.
     *
     * @private
     * @return {*}  Base URL of the API Gateway for the current environment.
     * @memberof Insight
     */
    _getApiUrl() {
        // Always return the overriden API URL if it was provided
        if (this._apiUrlOverride) {
            return this._apiUrlOverride;
        }
        const domain = (0, url_1.getDomainNameForEnvironment)(this._environment);
        return `api.${domain}`;
    }
    /**
     * Gets the base Icebox URL for the environment specified when instantiating the SDK.
     * Used as the base for Icebox snapshot calls.
     *
     * @private
     * @return {*}  {string}
     * @memberof Insight
     */
    _getIceboxUrl() {
        // Always return the overriden API URL if it was provided
        if (this._iceboxUrlOverride) {
            return this._iceboxUrlOverride;
        }
        const domain = (0, url_1.getDomainNameForEnvironment)(this._environment);
        return `icebox.${domain}`;
    }
    /**
     * Gets the base Faucet URL for the environment specified when instantiating the SDK.
     * Used as the base for Faucet stream connections.
     *
     * @private
     * @return {*}  {string}
     * @memberof Insight
     */
    _getFaucetUrl() {
        // Always return the overriden API URL if it was provided
        if (this._faucetUrlOverride) {
            return this._faucetUrlOverride;
        }
        const domain = (0, url_1.getDomainNameForEnvironment)(this._environment);
        return `faucet.${domain}`;
    }
    /**
     * Gets the base Syft URL for the environment specified when instantiating the SDK.
     * Used as the base for Syft metadata calls.
     *
     * @private
     * @return {*}  {string}
     * @memberof Insight`
     */
    _getSyftUrl() {
        // Always return the overriden API URL if it was provided
        if (this._syftUrlOverride) {
            return this._syftUrlOverride;
        }
        const domain = (0, url_1.getDomainNameForEnvironment)(this._environment);
        return `syft.${domain}`;
    }
    /**
     * Gets the base Quay URL for the environment specified when instantiating the SDK.
     * Used as the base for Quay message calls.
     *
     * @private
     * @return {*}  {string}
     * @memberof Insight
     */
    _getQuayUrl() {
        // Always return the overriden API URL if it was provided
        if (this._quayUrlOverride) {
            return this._quayUrlOverride;
        }
        const domain = (0, url_1.getDomainNameForEnvironment)(this._environment);
        return `messages.${domain}`;
    }
    //*** OTHER ***/
    /**
     * Returns a collection of snapshots for the channels
     *
     * @param {any[]} channels
     * @return {*}  {Promise<any>}
     * @memberof Insight
     */
    async combinedSnapshot(channels) {
        return await this._icebox.combinedSnapshot(channels);
    }
    /**
     * The event emitter over which all streaming data is emitted.
     * Use the "on" method to interact with the stream data.
     * Prerequisite: basic knowledge for Node.js Event Emitter.
     *
     * @return {*}  {<EventEmitter>}
     * @memberof Insight
     */
    get stream() {
        return this._faucet;
    }
    /**
     * Returns an array of SymbolMetadata for  supplemental symbols matching the provided pattern.
     * Searches can be on symbol name (in English, Japanese, or Kana), as well as
     * Japanese keywords and symbol codes.
     *
     * @param {string} pattern - Required. The search pattern to use. Wildcards and other special characters are not supported. Syft will look up the given pattern in its precomputed match database and return the metadata for all symbols that contain the pattern as given.
     * @param {number?} top - Limits the returned symbols to a maximum number. Must be a positive integer in the range 1-1000 (inclusive). If no value is provided, if it is set to a non-number, or if a value greater than 1000 is provided, this parameter is set to 1000. If a value less than 1 is provided, this parameter is set to 1.
     * @param {number?} skip - Skips past a certain number of symbols. Must be a non-negative integer. The top limiter is applied after skip. If the value of skip is greater than or equal to the total number of symbols, no symbols will be returned. If no value is provided, if it is set to a non-number, or if a negative value is provided, this parameter is set to 0.
     * @return {*}  {Promise<ApiResponse<SymbolMetadata[]>>}
     * @memberof Insight
     * @example
     * Searching for USDJPY
     * ```ts
     * let symbol = await sdk.supplementalSymbolSearch('USDJPY', 1, 0);
     * console.log(symbol);
     * ```
     */
    async supplementalSymbolSearch(pattern, top, skip) {
        return await this._syft.supplementalSymbolSearch(pattern, top, skip);
    }
    /**
     * Returns an array of SymbolMetadata for the specified symbols. MAX 50 per request
     *
     * @param {string} symbol - An array list of up to 50 symbols. There is a limit of up to 50 symbols returned in one request.
     * @return {*}  {Promise<ApiResponse<SymbolMetadata[]>}
     * @memberof Insight
     * @example
     * Request metadata for JP:8698-TS, USEQ, AAPL and JP:$MNK
     * ```ts
     *   let symbols = await sdk.symbolsMetadata(['JP:8698-TS', 'USEQ', 'AAPL', 'JP:$MNK']);
     *   console.log(symbols);
     * ```
     */
    async symbolsMetadata(symbols) {
        return await this._syft.symbolsMetadata(symbols);
    }
    /**
     * Returns an array of Up-Down Ratios
     *
     * @return {*}  {Promise<ApiResponse<UpDownRatio[]>>}
     * @memberof Insight
     */
    async upDownRatios() {
        return await this._syphon.upDownRatios();
    }
    /**
     * Returns an array of historical bars for a given symbol/interval
     *
     * @param {string} symbol symbol of the historical bar to retrieve (e.g. 'JP:8698-TS')
     * @param {string} interval Allowed interval
     * - '5min',
     * - '1hour'
     * - '1day',
     * - '1week',
     * - '1month',
     * - '1quarter'
     * @return {*}  {Promise<SymbolHistoricalBars>>}
     * @memberof Insight
     */
    async getHistoricalBarsBySymbol(symbol, interval) {
        return await this._syphon.getHistoricalBarsBySymbol(symbol, interval);
    }
    /**
     * Returns an array of historical bars for a given symbol/interval
     *
     * @param {string[]} symbols Array of symbols/intervals to fetch the bars (e.g. 'JP:8698-TS/5min'). Allowed intervals:
     * - '5min',
     * - '1hour'
     * - '1day',
     * - '1week',
     * - '1month',
     * - '1quarter'
     * @return {*}  {Promise<SymbolHistoricalBars>>}
     * @memberof Insight
     */
    async getHistoricalBars(symbols) {
        return await this._syphon.getHistoricalBars(symbols);
    }
}
exports.Insight = Insight;
// Since the following code is to be used only for browser and the window
// property cannot be easily mocked when executing the tests in nodejs,
// the following comment was added so it will be ignored in the test
// coverage
/* istanbul ignore next */
if (typeof window === 'object') {
    window.Insight = Insight;
}
//# sourceMappingURL=insight.js.map